import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import appConfig from '../../../config/config';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Spinner, Form, Row, FormGroup, Button, Col, Input
} from 'reactstrap';
import { renderInput, renderTextArea, renderDatePicker, renderDropdown, renderMultiselect, renderCheckbox } 
from "../../common/renderinput";
import {Loading,LoadingDone,Reset,Success,Error} from "../../../actions/loading"

import { connect } from 'react-redux';
import axios from 'axios';

const divStyle = {
    backgroundColor: '#fff'
};
const padStyle = {
    paddingTop: '5px', paddingLeft : '0px'
};
const diagStyle = {
    width: '897px', height:'802px'
}
const q = [
    {valueField: 1, textField:"Title"},
    {valueField: 2, textField:"Appraisal"},
    {valueField: 3, textField:"AVM"},
    {valueField: 4, textField:"Flood/BPO"},
    {valueField: 5, textField:"Evaluation"},
    {valueField: 6, textField:"PCR Property Inspection Condition Report"}
];
class EditProductForm extends Component {
    constructor(props) {
        super(props);
        this.state = { display:true}
    }
    toggle = (val) => {
        this.setState({...this.state, display : !val})
    }

    handleSave = (values) => {
        //Use axios to send request
        this.props.Loading()
        axios.post(
            appConfig.apiGateway.searchUrl,
            JSON.stringify({...values, "Action":"PRODUCT"}, null, 2),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then(response => {
            this.props.LoadingDone()
            this.props.Success("Added product")
           // this.props.setData(JSON.parse(response.data.body));
        }, error => {
            this.props.LoadingDone()
            this.props.Error("Unable to save")
        });

    }



    render() {
        return (
            <>
            <div>
                    <Modal
                        isOpen={this.state.display}
                        toggle={this.toggle}
                        contentClassName="custom-modal-style">
                            <form
                            onSubmit={this.props.handleSubmit(this.handleSave)}
                            style={{ marginLeft: "0%", marginRight: "5%" }}
                            >
                                <ModalHeader>Add Product</ModalHeader>
                                <ModalBody>
                                <div className="form-row col-12" style={padStyle}>
                                    <div className="col-12" style={divStyle}>
                                        <Field name="ProductId" component={renderInput} label="ProductId" />
                                    </div>
                                    <div className="col-12" style={divStyle}>
                                        <Field name="ProductName" component={renderInput} label="ProductName" />
                                    </div>
                                    <div className="col-12" style={divStyle}>
                                        <Field name="ProductGroup" component={renderDropdown} label="Product Group" data={q} textField="textField" valueField="valueField" isLabel={false} />
                                    </div>
                                </div>
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="primary" type="submit">
                                    {this.props.loading.loading && <Spinner />}
                                    {!this.props.loading.loading && <span>Save</span>}
                                    </Button>
                                    <Button
                                    color="secondary"
                                    onClick={() => this.props.Add(false)}>
                                    Cancel
                                    </Button>
                                </ModalFooter>
                            </form>
                    </Modal>
            </div>
            </>
        );
    }
}

const validate = (formvalues) => {
}
const mapStatetoProps = state => {
    return { session: state.session,
        loading : state.loading }
}
var sf = reduxForm({
    form: 'EditProductForm',
    validate
})(EditProductForm);
sf = connect(mapStatetoProps,{LoadingDone,Loading,Success,Error,Reset})(sf);
export default sf;